export const DEFAULT_TASK_IMAGE =
  "https://res.cloudinary.com/laborhack/image/upload/v1616078821/laborhack-custom_keczes.png";

export const LABORHACK_SUPPORT_PHONE = "+234 913 159 8380";

export const LABORHACK_SUPPORT_EMAIL = "support@laborhack.com";

export const CLAIMS_NAMESPACE = "https://api.laborhack.com";

export const LABORHACK_PRO_TERMS_OF_USE_URL =
  "https://laborhack-assets.s3.amazonaws.com/legal/pro-terms-of-use.pdf";

export const LABORHACK_PRIVACY_POLICY_URL =
  "https://laborhack-assets.s3.amazonaws.com/legal/privacy-policy.pdf";

export const LABORHACK_TERMS_OF_USE_URL =
  "https://laborhack-assets.s3.amazonaws.com/legal/terms-of-use.pdf";

export const LABORHACK_COOKIE_POLICY_URL =
  "https://laborhack-assets.s3.amazonaws.com/legal/cookie-policy.pdf";

export const LABORHACK_CAREERS_URL = "https://laborhack.grovehr.com/careers";

export const LABORHACK_SCHEDULE_DEMO_URL =
  "https://calendly.com/laborhacksupport/laborhack-discovery-call";
